import React from 'react'
import styled from '@emotion/styled'
import { PartnerItems } from '../PartnerItem/PartnerItems'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { GoTo } from 'ui/inputs/GoTo'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { Product } from 'services/ContentfulService/models/product'
import { ShowOnDesktop } from 'components/elements/ShowHide'

interface Props {
	partners: Partner[]
	product: Product
}

export const PartnerSection = ({ partners, product }: Props): JSX.Element => {
	return (
		<PartnersWrapper>
			<PartnersTop>
				<PartnersTitle>Our {product.name} Network</PartnersTitle>
				<ShowOnDesktop>
					<GoTo direction="none" href="/learn/partners">{`Show all ${product.partnerNoun}s`}</GoTo>
				</ShowOnDesktop>
			</PartnersTop>
			<PartnerItems partners={partners} />
			<ShowItemOnMobile>
				<GoTo direction="none" href="/learn/partners">{`Show all ${product.partnerNoun}s`}</GoTo>
			</ShowItemOnMobile>
		</PartnersWrapper>
	)
}

const PartnersWrapper = styled.div``

const PartnersTop = styled.div`
	margin-bottom: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		margin-bottom: 0;
	}
`

const PartnersTitle = styled.h2``

const ShowItemOnMobile = styled.div`
	display: none;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		display: flex;
		align-items: center;
		justify-content: center;
	}
`
